import React, { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Button } from '../ui/Button';
import { Check, ShieldCheck, Clock, Gift } from 'lucide-react';
export function OfferSection() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  const [viewers, setViewers] = useState(27);
  const priceRef = useRef(null);
  const priceInView = useInView(priceRef, {
    once: true,
    margin: '-80px'
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return prev;
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Fluctuating viewer count
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(Math.floor(Math.random() * 9) + 23);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  return <section id="offer" className="py-20 bg-white" data-id="element-168">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-169">
        <div className="bg-brand-dark rounded-3xl p-1 shadow-2xl overflow-hidden" data-id="element-170">
          <div className="bg-white rounded-[20px] p-8 md:p-12 text-center relative overflow-hidden" data-id="element-171">
            {/* Badge */}
            <div className="absolute top-0 right-0 bg-brand-gold text-brand-dark font-bold px-6 py-2 rounded-bl-xl text-sm uppercase tracking-wider animate-pulse" data-id="element-172">
              Oferta Expira Pronto
            </div>

            {/* Viewer count */}
            <motion.div initial={{
            opacity: 0,
            y: -10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mb-4 flex justify-center" data-id="element-173">
              <div className="flex items-center gap-2 text-xs font-semibold text-gray-500 bg-gray-50 border border-gray-100 px-3 py-1.5 rounded-full" data-id="element-174">
                <span className="relative flex h-2 w-2" data-id="element-175">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-176"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-177"></span>
                </span>
                <motion.span key={viewers} initial={{
                opacity: 0
              }} animate={{
                opacity: 1
              }} data-id="element-178">
                  {viewers} personas viendo esto ahora
                </motion.span>
              </div>
            </motion.div>

            <div className="mb-8 flex justify-center" data-id="element-179">
              <div className="bg-red-50 text-red-600 px-4 py-2 rounded-lg font-bold flex items-center border border-red-100" data-id="element-180">
                <Clock className="h-5 w-5 mr-2" data-id="element-181" />
                La oferta termina en:{' '}
                {String(timeLeft.minutes).padStart(2, '0')}:
                {String(timeLeft.seconds).padStart(2, '0')}
              </div>
            </div>

            <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-dark mb-2" data-id="element-182">
              Únete al Reset Metabólico
            </h2>
            <p className="text-gray-500 mb-8" data-id="element-183">
              Acceso inmediato • Descarga digital • Empieza hoy mismo
            </p>

            {/* Price block */}
            <div ref={priceRef} className="flex flex-col items-center gap-2 mb-10" data-id="element-184">
              <div className="text-sm text-gray-500 uppercase tracking-widest font-semibold mb-1" data-id="element-185">
                Valor total del paquete
              </div>
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} animate={priceInView ? {
              opacity: 1,
              x: 0
            } : {}} transition={{
              duration: 0.5
            }} className="text-2xl text-gray-400 font-serif relative inline-block" data-id="element-186">
                $148 USD
                <motion.div initial={{
                scaleX: 0
              }} animate={priceInView ? {
                scaleX: 1
              } : {}} transition={{
                duration: 0.4,
                delay: 0.5
              }} style={{
                originX: 0
              }} className="absolute top-1/2 left-0 right-0 h-0.5 bg-gray-400" data-id="element-187" />
              </motion.div>
              <div className="text-sm text-gray-500 font-medium" data-id="element-188">
                Precio promocional
              </div>
              <motion.div initial={{
              scale: 0.5,
              opacity: 0
            }} animate={priceInView ? {
              scale: 1,
              opacity: 1
            } : {}} transition={{
              type: 'spring',
              stiffness: 200,
              damping: 15,
              delay: 0.3
            }} className="text-6xl md:text-7xl font-bold text-brand-dark font-serif leading-none" data-id="element-189">
                $6.36
                <span className="text-2xl text-gray-500 font-sans font-normal ml-2" data-id="element-190">
                  USD
                </span>
              </motion.div>
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={priceInView ? {
              opacity: 1,
              y: 0
            } : {}} transition={{
              delay: 0.6
            }} className="mt-2 bg-green-100 text-green-700 text-sm font-bold px-4 py-1.5 rounded-full" data-id="element-191">
                Ahorras $141.64 — 96% OFF
              </motion.div>
            </div>

            {/* What's included */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={priceInView ? {
            opacity: 1,
            y: 0
          } : {}} transition={{
            delay: 0.7
          }} className="max-w-md mx-auto mb-10 space-y-0 text-left border border-gray-100 rounded-2xl overflow-hidden" data-id="element-192">
              <div className="bg-gray-50 px-5 py-2 text-xs font-bold text-gray-400 uppercase tracking-widest" data-id="element-193">
                Qué incluye
              </div>

              {/* Producto principal */}
              <div className="bg-brand-dark/5 px-5 py-2 text-xs font-bold text-brand-dark uppercase tracking-widest border-t border-gray-100" data-id="element-194">
                Producto principal
              </div>
              {[{
              icon: <Check className="h-5 w-5 text-green-500" data-id="element-195" />,
              label: 'Reset Metabólico — Protocolo de 7 días',
              value: '$97',
              isMain: true
            }, {
              icon: <Check className="h-5 w-5 text-green-500" data-id="element-196" />,
              label: 'Guía de compras para USA',
              value: 'incluido',
              isMain: false
            }, {
              icon: <Check className="h-5 w-5 text-green-500" data-id="element-197" />,
              label: 'Ritual anti-cortisol de 5 minutos',
              value: 'incluido',
              isMain: false
            }].map((item, i) => <div key={i} className="flex items-center justify-between px-5 py-3 border-t border-gray-100 bg-white" data-id="element-198">
                  <div className="flex items-center gap-3" data-id="element-199">
                    {item.icon}
                    <span className="font-medium text-gray-700" data-id="element-200">
                      {item.label}
                    </span>
                  </div>
                  {item.isMain ? <span className="text-sm font-bold text-gray-500" data-id="element-201">
                      {item.value}
                    </span> : <span className="text-xs font-semibold text-gray-400 uppercase tracking-wide" data-id="element-202">
                      {item.value}
                    </span>}
                </div>)}
              {/* Subtotal producto */}
              <div className="flex items-center justify-between px-5 py-2 border-t border-gray-100 bg-gray-50/80" data-id="element-203">
                <span className="text-xs font-bold text-gray-500 uppercase tracking-wide" data-id="element-204">
                  Subtotal producto
                </span>
                <span className="text-sm font-bold text-gray-500" data-id="element-205">$97</span>
              </div>

              {/* Bonos gratis */}
              <div className="bg-brand-gold/10 px-5 py-2 text-xs font-bold text-brand-dark uppercase tracking-widest border-t border-brand-gold/30" data-id="element-206">
                Bonos gratis — Solo hoy
              </div>
              {[{
              label: 'Lista de Emergencia Anti-Inflamación',
              value: '$27'
            }, {
              label: 'Protocolo de Mañana de 10 Minutos',
              value: '$27'
            }, {
              label: 'Guía de Restaurantes USA',
              value: '$27'
            }].map((item, i) => <div key={i} className="flex items-center justify-between px-5 py-3 border-t border-brand-gold/20 bg-brand-gold/5" data-id="element-207">
                  <div className="flex items-center gap-3" data-id="element-208">
                    <Gift className="h-5 w-5 text-brand-gold flex-shrink-0" data-id="element-209" />
                    <span className="font-medium text-gray-700" data-id="element-210">
                      {item.label}
                    </span>
                  </div>
                  <div className="flex flex-col items-end" data-id="element-211">
                    <span className="text-xs font-bold text-gray-400 line-through" data-id="element-212">
                      {item.value}
                    </span>
                    <span className="text-xs font-black text-green-600 uppercase tracking-wide" data-id="element-213">
                      FREE
                    </span>
                  </div>
                </div>)}

              <div className="flex items-center justify-between px-5 py-3 border-t border-gray-200 bg-gray-50" data-id="element-214">
                <span className="text-sm font-bold text-gray-500 uppercase tracking-wide" data-id="element-215">
                  Total
                </span>
                <span className="text-sm font-bold text-gray-400 line-through" data-id="element-216">
                  $148 USD
                </span>
              </div>
            </motion.div>

            {/* CTA Button with shimmer */}
            <div className="relative mb-6 overflow-hidden rounded-xl" data-id="element-217">
              <Button variant="primary" size="xl" fullWidth href="https://www.betterbysteps.com/cart/44216026333277:1" className="text-xl shadow-xl bg-brand-gold text-brand-dark font-black relative z-10" data-id="element-218">
                SÍ, QUIERO MI RESET POR $6.36
              </Button>
              <motion.div className="absolute inset-0 z-20 pointer-events-none" animate={{
              x: ['-100%', '200%']
            }} transition={{
              repeat: Infinity,
              duration: 3,
              ease: 'easeInOut',
              repeatDelay: 1
            }} style={{
              background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.4) 50%, transparent 100%)',
              width: '50%'
            }} data-id="element-219" />
            </div>

            <div className="flex flex-col md:flex-row justify-center items-center gap-4 text-sm text-gray-500" data-id="element-220">
              <div className="flex items-center" data-id="element-221">
                <ShieldCheck className="h-4 w-4 mr-2" data-id="element-222" />
                Pago 100% Seguro
              </div>
              <div className="flex items-center" data-id="element-223">
                <Clock className="h-4 w-4 mr-2" data-id="element-224" />
                Entrega Inmediata por Email
              </div>
            </div>

            <p className="mt-6 text-xs text-gray-400 max-w-sm mx-auto" data-id="element-225">
              *Precio promocional válido solo por tiempo limitado. El precio
              volverá a su valor normal pronto.
            </p>
          </div>
        </div>
      </div>
    </section>;
}